<div *ngIf="!showSpinnerProjects" class="sidebar-container">
  <div class="sidebar-header" [class.sidebar-header-expanded]="visibleSidebar">
    <button
      *ngIf="visibleSidebar"
      type="button"
      class="project-logo-button project-logo-button-header"
      (click)="openProjectSettings()"
      [attr.aria-label]="
        'Open Settings for ' + (currentProject?.name || 'current project')
      "
    >
      <img
        *ngIf="projectLogoAvailable"
        [src]="projectLogo"
        (error)="onImageError($event)"
        class="project-logo"
        alt=""
      />
      <span
        *ngIf="!projectLogoAvailable"
        class="project-name project-name-header"
        [title]="currentProject?.name"
        pTooltip="Context Management"
        tooltipPosition="right"
      >
        {{ currentProject?.name }}
      </span>
    </button>
    <button
      pButton
      type="button"
      [icon]="arrowIcon"
      iconPos="left"
      class="p-button-rounded p-button-outlined p-button-secondary"
      (click)="handleSidebarOpen()"
      aria-label="Toggle sidebar"
    ></button>
  </div>

  <div *ngIf="!visibleSidebar" class="sidebar-sections">
    <button
      type="button"
      class="project-logo-button"
      (click)="openProjectSettings()"
      [attr.aria-label]="
        'Open Settings for ' + (currentProject?.name || 'current project')
      "
      pTooltip="Context Management"
      tooltipPosition="right"
    >
      <img
        *ngIf="projectLogoAvailable"
        [src]="projectLogo"
        (error)="onImageError($event)"
        class="project-logo"
        alt=""
      />
      <span
        *ngIf="!projectLogoAvailable"
        class="project-name project-name-compact"
        [title]="currentProject?.name"
      >
        {{ currentProject?.name }}
      </span>
    </button>
    <div class="accordion-box">
      <p-accordion (onOpen)="handleShowTopicSection($event)" class="mini">
        <div class="sidebar-group-heading sidebar-group-heading-compact">
          <span class="sidebar-group-heading-text">My Context</span>
        </div>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[2]"
          [(selected)]="activeState[2]"
          [transitionOptions]="animationOptions"
          pTooltip="Topics"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-comments"></i> {{ headerTopic
            }}<app-badge
              [total]="topicTotalItems"
              [highlight]="highlightedBadges.topics"
            ></app-badge
          ></ng-template>
          <app-topics-sidebar
            [labelFilter]="{ label: 'Competitor', exclude: true }"
          ></app-topics-sidebar>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[7]"
          [(selected)]="activeState[7]"
          [transitionOptions]="animationOptions"
          pTooltip="Competitors"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-building"></i>
            <span *ngIf="visibleSidebar">Competitors</span
            ><app-badge
              [total]="competitorTotalItems"
              [highlight]="highlightedBadges.topics"
            ></app-badge
          ></ng-template>
          <app-topics-sidebar
            [labelFilter]="{ label: 'Competitor' }"
          ></app-topics-sidebar>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[0]"
          [(selected)]="activeState[0]"
          [transitionOptions]="animationOptions"
          pTooltip="Authors"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-users" style="font-size: 1.2rem"></i>
            {{ headerAuthor
            }}<app-badge
              [total]="authorTotalItems"
              [highlight]="highlightedBadges.authors"
            ></app-badge
          ></ng-template>
          <app-sidebar-author-list></app-sidebar-author-list>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[1]"
          [(selected)]="activeState[1]"
          [transitionOptions]="animationOptions"
          pTooltip="Outlets"
        >
          <ng-template pTemplate="header"
            ><i
              class="fa-regular fa-newspaper fa-fw"
              style="font-size: 1.2rem"
            ></i>
            {{ headerOutlet
            }}<app-badge
              [total]="outletTotalItems"
              [highlight]="highlightedBadges.outlets"
            ></app-badge
          ></ng-template>
          <app-sidebar-outlet-list></app-sidebar-outlet-list>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[3]"
          [(selected)]="activeState[3]"
          [transitionOptions]="animationOptions"
          pTooltip="Articles"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-paperclip"></i> {{ headerContentItems
            }}<app-badge
              [total]="contentItemsTotalItems"
              [highlight]="highlightedBadges.contentItems"
            ></app-badge
          ></ng-template>
          <app-sidebar-content-items></app-sidebar-content-items>
        </p-accordionTab>
        <div class="sidebar-group-heading sidebar-group-heading-compact">
          <span class="sidebar-group-heading-text">Context Tools</span>
        </div>
        <p-accordionTab
          [style.display]="hasReportingAccess() ? null : 'none'"
          [class.sidebar-section-expanded]="activeState[6]"
          [(selected)]="activeState[6]"
          [transitionOptions]="animationOptions"
          pTooltip="Reports"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-chart-line"></i> {{ headerReports
            }}<app-badge
              [total]="reportsTotalItems"
              [highlight]="highlightedBadges.reports"
            ></app-badge
          ></ng-template>
          <app-sidebar-reports-list></app-sidebar-reports-list>
        </p-accordionTab>
        <p-accordionTab
          [style.display]="hasReportingAccess() ? null : 'none'"
          class="news-feed"
          [(selected)]="activeState[4]"
          [transitionOptions]="animationOptions"
          pTooltip="News Feed"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-wifi rss-icon"></i>
            {{ headerNewsFeed }}</ng-template
          >
        </p-accordionTab>
        <p-accordionTab
          *ngIf="isDev()"
          class="ask-ai"
          [selected]="false"
          [transitionOptions]="animationOptions"
          pTooltip="Ask AI"
        >
          <ng-template pTemplate="header"
            ><span
              class="ask-ai-action"
              (click)="$event.stopPropagation(); toggleChat()"
              ><i class="pi pi-fw pi-android"></i> {{ headerAskAi }}</span
            ></ng-template
          >
        </p-accordionTab>
        <p-accordionTab
          class="excel"
          [(selected)]="activeState[5]"
          [transitionOptions]="animationOptions"
          pTooltip="Export Data"
        >
          <ng-template pTemplate="header"
            ><span
              class="export-action"
              role="button"
              tabindex="0"
              (click)="$event.stopPropagation(); promptExportFilename()"
              (keydown.enter)="$event.stopPropagation(); promptExportFilename()"
              (keydown.space)="
                $event.preventDefault();
                $event.stopPropagation();
                promptExportFilename()
              "
              ><i
                [class]="
                  isExportingExcel
                    ? 'pi pi-spin pi-spinner'
                    : 'pi pi-fw pi-download'
                "
              ></i>
              {{ headerExportExcel }}</span
            ></ng-template
          >
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <div *ngIf="visibleSidebar" class="sidebar-sections scroll-sidebar-mini">
    <div class="accordion-box">
      <p-accordion (onOpen)="handleShowTopicSection($event)" class="full">
        <div class="sidebar-group-heading">
          <span class="sidebar-group-heading-text">My Context</span>
        </div>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[2]"
          [(selected)]="activeState[2]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-comments p-mr-2"></i>
            {{ headerTopic }}
            <app-badge
              [total]="topicTotalItems"
              [highlight]="highlightedBadges.topics"
            ></app-badge>
          </ng-template>
          <app-topics-sidebar
            [labelFilter]="{ label: 'Competitor', exclude: true }"
          ></app-topics-sidebar>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[7]"
          [(selected)]="activeState[7]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-building p-mr-2"></i>
            Competitors
            <app-badge
              [total]="competitorTotalItems"
              [highlight]="highlightedBadges.topics"
            ></app-badge>
          </ng-template>
          <app-topics-sidebar
            [labelFilter]="{ label: 'Competitor' }"
          ></app-topics-sidebar>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[0]"
          [(selected)]="activeState[0]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-users p-mr-2" style="font-size: 1.2rem"></i>
            {{ headerAuthor }}
            <app-badge
              [total]="authorTotalItems"
              [highlight]="highlightedBadges.authors"
            ></app-badge>
          </ng-template>
          <app-sidebar-author-content></app-sidebar-author-content>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[1]"
          [(selected)]="activeState[1]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><i
              class="fa-regular fa-newspaper fa-fw p-mr-2"
              style="font-size: 1.2rem"
            ></i>
            {{ headerOutlet }}
            <app-badge
              [total]="outletTotalItems"
              [highlight]="highlightedBadges.outlets"
            ></app-badge>
          </ng-template>
          <app-sidebar-outlet-content></app-sidebar-outlet-content>
        </p-accordionTab>
        <p-accordionTab
          [class.sidebar-section-expanded]="activeState[3]"
          [(selected)]="activeState[3]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-paperclip p-mr-2"></i>
            {{ headerContentItems }}
            <app-badge
              [total]="contentItemsTotalItems"
              [highlight]="highlightedBadges.contentItems"
            ></app-badge>
          </ng-template>
          <app-sidebar-content-items></app-sidebar-content-items>
        </p-accordionTab>
        <div class="sidebar-group-heading">
          <span class="sidebar-group-heading-text">Context Tools</span>
        </div>
        <p-accordionTab
          [style.display]="hasReportingAccess() ? null : 'none'"
          [class.sidebar-section-expanded]="activeState[6]"
          [(selected)]="activeState[6]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-chart-line p-mr-2"></i>
            {{ headerReports }}
            <app-badge
              [total]="reportsTotalItems"
              [highlight]="highlightedBadges.reports"
            ></app-badge>
          </ng-template>
          <app-sidebar-reports-list></app-sidebar-reports-list>
        </p-accordionTab>
        <p-accordionTab
          [style.display]="hasReportingAccess() ? null : 'none'"
          class="news-feed"
          [(selected)]="activeState[4]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><i class="pi pi-fw pi-wifi p-mr-2 rss-icon"></i>
            {{ headerNewsFeed }}
          </ng-template>
        </p-accordionTab>
        <p-accordionTab
          *ngIf="isDev()"
          class="ask-ai"
          [selected]="false"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><span
              class="ask-ai-action"
              (click)="$event.stopPropagation(); toggleChat()"
              ><i class="pi pi-fw pi-android p-mr-2"></i>
              {{ headerAskAi }}</span
            >
          </ng-template>
        </p-accordionTab>
        <p-accordionTab
          class="excel"
          [(selected)]="activeState[5]"
          [transitionOptions]="animationOptions"
        >
          <ng-template pTemplate="header"
            ><span
              class="export-action"
              role="button"
              tabindex="0"
              (click)="$event.stopPropagation(); promptExportFilename()"
              (keydown.enter)="$event.stopPropagation(); promptExportFilename()"
              (keydown.space)="
                $event.preventDefault();
                $event.stopPropagation();
                promptExportFilename()
              "
              ><i
                [class]="
                  isExportingExcel
                    ? 'pi pi-spin pi-spinner p-mr-2'
                    : 'pi pi-fw pi-download p-mr-2'
                "
              ></i>
              {{ headerExportExcel }}</span
            >
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>
